import {RuntimeConfigEnvironment} from "../interface/environment.interface";

export class EnvironmentModel implements RuntimeConfigEnvironment {
  production = true;
  portalOnfUrl = '';
  baseUrl = '';
  nfId = '';

}
